"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _image = _interopRequireDefault(require("./image"));
var _utils = require("../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * Creates a `highlight` content model
 *
 * @param {object} entry
 * @param {object} entry.sys
 * @param {string} entry.sys.id
 * @param {object} entry.sys.contentType
 * @param {object} entry.sys.contentType.sys
 * @param {string} entry.sys.contentType.sys.id
 * @param {object} entry.fields
 * @param {string} entry.fields.image - A Contentful asset
 * @param {string} entry.fields.ringColour - Colour of the image border
 * @param {string} entry.fields.backgroundColour - Colour of the main background
 * @param {string} entry.fields.type - The highlight type
 * @param {(string|null)} entry.fields.content - A rich text field of content
 * @returns {object} `highlight` content model
 */
var createHighlight = function createHighlight(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    type: (0, _utils.getProp)(fields, 'type') ? fields.type.toLowerCase() : null,
    image: (0, _utils.getProp)(fields, 'image') ? (0, _image["default"])(fields === null || fields === void 0 ? void 0 : fields.image) : null,
    ringColour: (0, _utils.getProp)(fields, 'ringColour'),
    backgroundColour: (0, _utils.getProp)(fields, 'backgroundColour'),
    content: (0, _utils.getProp)(fields, 'content')
  };
};
var _default = createHighlight;
exports["default"] = _default;